var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.workMode.isModeAurus)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.$t('warning_template'))}}):_vm._e(),(_vm.workMode.isModeSollers)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.$t('warning_template_sollers'))}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }